/**
 * Blog PDF Export
 */

export const downloadBlogPdf = (blog) => {
  const now = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  let sectionsHtml = '';
  blog.sections?.forEach((section, idx) => {
    const paragraphs = section.content
      .split('\n')
      .filter(p => p.trim())
      .map(p => `<p style="color:#374151;font-size:14px;line-height:1.8;margin:0 0 12px 0;">${p}</p>`)
      .join('');

    sectionsHtml += `
      <div style="page-break-inside:avoid;margin-bottom:28px;">
        <h2 style="font-size:18px;font-weight:600;color:#0B3C5D;margin:0 0 12px 0;padding-bottom:8px;border-bottom:2px solid #d4a843;">${section.heading}</h2>
        ${paragraphs}
      </div>`;
  });

  const html = `
    <html>
    <head>
      <style>
        @page { margin: 40px; size: A4; }
        body { font-family: Georgia, 'Times New Roman', serif; color: #1f2937; line-height: 1.6; }
        .header { text-align: center; margin-bottom: 36px; padding-bottom: 24px; border-bottom: 1px solid #e5e7eb; }
        .header .tag { font-size: 11px; text-transform: uppercase; letter-spacing: 3px; color: #d4a843; font-family: sans-serif; }
        .header h1 { font-size: 28px; color: #0B3C5D; margin: 12px 0 8px 0; }
        .header .subtitle { font-size: 15px; color: #6b7280; font-style: italic; }
        .footer { margin-top: 32px; text-align: center; font-size: 10px; color: #9ca3af; border-top: 1px solid #e5e7eb; padding-top: 12px; font-family: sans-serif; }
      </style>
    </head>
    <body>
      <div class="header">
        <p class="tag">Travel Blog</p>
        <h1>${blog.title || 'My Travel Blog'}</h1>
        ${blog.subtitle ? `<p class="subtitle">${blog.subtitle}</p>` : ''}
      </div>
      ${sectionsHtml}
      <div class="footer">
        <p>Generated on ${now} | Triple A Travel Solutions | tripleabooking.com</p>
      </div>
    </body>
    </html>
  `;

  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${getBlogPdfFileName(blog).replace(/[^a-zA-Z0-9 ]/g, '-')}.html`;
    a.click();
    URL.revokeObjectURL(url);
    return;
  }
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.onload = () => {
    printWindow.print();
  };
};

export const getBlogPdfFileName = (blog) => {
  return blog?.title || 'My Travel Blog';
};
